import Image from 'next/image';
import { SvgAcademyLogo } from 'components/Svgs';
import SC from './style';
import ImgBg from '../../../../public/connect-left-background.png';

const LoginLayout = ({ children, mobile }) => (
  <SC.DivLoginLayout>
    {!mobile && (
      <SC.DivLeftSection>
        <SC.ImgLogo>
          <SvgAcademyLogo />
        </SC.ImgLogo>
        <SC.ImgBg>
          <Image
            src={ImgBg}
            alt="connect-left-bg"
            fill
            sizes="100vw"
            style={{
              objectPosition: 'left top',
            }}
          />
        </SC.ImgBg>
      </SC.DivLeftSection>
    )}

    <SC.DivRightSection mobile={mobile}>{children}</SC.DivRightSection>
  </SC.DivLoginLayout>
);

export default LoginLayout;
